import { render, staticRenderFns } from "./generaciones-listado.vue?vue&type=template&id=70f6e6ae&"
import script from "./generaciones-listado.component.ts?vue&type=script&lang=ts&"
export * from "./generaciones-listado.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports